export const GET_USER_DATA = "GET_USER_DATA";
export const CHANGE_DATA = "CHANGE_DATA";
export const SET_USERS = "SET_USERS";
export const SET_EVALUATORS = "SET_EVALUATORS";
export const SET_USERS_FILTERED = "SET_USERS_FILTERED";
